import React from 'react';

import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import classnames from 'classnames';
import {
  HistoryEmploymentItemModel,
} from 'forms/sections/history/employment/types';

import BranchCollection from 'components/Form/BranchCollection';
import AssignmentItem from './AssignmentItem';

type AssignmentsType = HistoryEmploymentItemModel['Assignments']
interface Props extends ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
  appendFieldTitle?: string
  branchFieldTitle?: string
  hideInitialBranchQuestionAssumeYes?: boolean
}

export default class Assignments extends ValidationElement<Props> {
  updateBranch = (values: Partial<AssignmentsType>) => {
    this.props.onUpdate({
      ...values,
    });
  };

  render() {
    return (
      <div className={classnames('assignments', this.props.className)}>
        <BranchCollection
          label={this.props.branchFieldTitle}
          labelSize="h4"
          appendLabel={this.props.appendFieldTitle}
          appendSize="h4"
          {...(this.props || {})}
          onUpdate={this.updateBranch}
          onError={this.props.onError}
          scrollIntoView={this.props.scrollIntoView}
          hideInitialBranchQuestionAssumeYes={this.props.hideInitialBranchQuestionAssumeYes}
        >
          <AssignmentItem
            attribute={this.props.attribute}
            name="Item"
            bind
            required={this.props.required}
          />
        </BranchCollection>
      </div>
    );
  }
}

Assignments.defaultProps = {
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
  appendFieldTitle: 'Do you have another unit or organization you were assigned to while at this duty station?',
  branchFieldTitle: 'Do you have a unit or organization at this Duty Station?',
  hideInitialBranchQuestionAssumeYes: false,
};
